import React from "react";
import styles from "./ActionMenuCheckbox.module.scss";
import { Checkbox } from "./../Forms"
import classNames from "classnames";

const ActionMenuCheckbox = ({ className, children, ariaLabel, dataTestId, ...props }) => {
    return <Checkbox {...props} className={classNames(styles.base, className)} ariaLabel={ariaLabel} dataTestId={dataTestId}>
        {children}
    </Checkbox>
};

export default ActionMenuCheckbox;